import * as React from "react"
import { cn } from "../../lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: "default" | "cosmic" | "stellar" | "nebula" | "void" | "glow"
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant = "default", ...props }, ref) => {
    const variants = {
      default: "border-input bg-background text-foreground",
      cosmic: "border-purple-500/30 bg-gradient-to-r from-purple-900/20 to-blue-900/20 text-white placeholder:text-purple-300/70 backdrop-blur-md",
      stellar: "border-blue-500/30 bg-gradient-to-r from-blue-900/20 to-cyan-900/20 text-white placeholder:text-blue-300/70 backdrop-blur-md",
      nebula: "border-pink-500/30 bg-gradient-to-r from-pink-900/20 to-purple-900/20 text-white placeholder:text-pink-300/70 backdrop-blur-md",
      void: "border-gray-500/30 bg-black/40 text-white placeholder:text-gray-400/70 backdrop-blur-lg",
      glow: "border-white/20 bg-white/10 text-white placeholder:text-white/50 backdrop-blur-md"
    }

    const focusEffects = {
      default: "focus-visible:ring-ring",
      cosmic: "focus-visible:ring-purple-500/50 focus-visible:border-purple-400/50 focus-visible:shadow-lg focus-visible:shadow-purple-500/20",
      stellar: "focus-visible:ring-blue-500/50 focus-visible:border-blue-400/50 focus-visible:shadow-lg focus-visible:shadow-blue-500/20",
      nebula: "focus-visible:ring-pink-500/50 focus-visible:border-pink-400/50 focus-visible:shadow-lg focus-visible:shadow-pink-500/20",
      void: "focus-visible:ring-gray-500/50 focus-visible:border-gray-400/50 focus-visible:shadow-lg focus-visible:shadow-black/40",
      glow: "focus-visible:ring-white/30 focus-visible:border-white/30 focus-visible:shadow-lg focus-visible:shadow-white/10"
    }

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-300",
          variants[variant],
          focusEffects[variant],
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }